import CancelablePromise from 'mn-utils/CancelablePromise';
import {get} from '../../http';
import {TCurrency, TFilter, TList, TUUID} from '@/types';
import {TListItem} from './types';
import {getInvoiceDetails, getInvoiceList} from './mock';

export function apiV2InvoiceList(params: TFilter<TListItem, {amount_currency: TCurrency}>): Promise<TList<TListItem>> {
  const url = '/f2c/v1/console/invoices';
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getInvoiceList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}

export function apiV2InvoiceGet(params: {id: TUUID}): Promise<TListItem> {
  const url = '/f2c/v1/console/invoice/' + params.id;
  if (process.env.MOCK) {
    const response = getInvoiceDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url);
}
